'use strict';

let theme = {

    init: function () {
        this.mobileOffcanvas();
        this.scrollCue();
        this.swiperSlider();
        this.smoothScrollToTop();
    },

    /**
     * Mobile Offcanvas Navigation
     * Handles dual offcanvas navigation for mobile with submenu support
     */
    mobileOffcanvas: () => {
        const mainOffcanvasElement = document.getElementById('offcanvasNavbar');
        const navbarToggler = document.querySelector('.navbar-toggler');

        if (!mainOffcanvasElement || !navbarToggler) {
            return;
        }

        const mainOffcanvas = new bootstrap.Offcanvas(mainOffcanvasElement);

        // Sync hamburger icon state
        mainOffcanvasElement.addEventListener('hidden.bs.offcanvas', () => {
            navbarToggler.setAttribute('aria-expanded', 'false');
            // Close all submenus when the main menu closes
            mainOffcanvasElement.querySelectorAll('.dropdown-menu.show').forEach(el => {
                el.classList.remove('show');
                el.previousElementSibling.setAttribute('aria-expanded', 'false');
            });
        });

        mainOffcanvasElement.addEventListener('shown.bs.offcanvas', () => {
            navbarToggler.setAttribute('aria-expanded', 'true');
        });

        // Handle mobile menu items with children
        const mobileParentItems = document.querySelectorAll('#offcanvasNavbar .menu-item-has-children > a.dropdown-toggle');

        mobileParentItems.forEach(item => {
            // Remove bootstrap data attribute to prevent conflicts
            item.removeAttribute('data-bs-toggle');

            item.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                const submenu = this.nextElementSibling;
                const isExpanded = this.getAttribute('aria-expanded') === 'true';

                if (submenu && submenu.classList.contains('dropdown-menu')) {
                    // Toggle current menu
                    if (isExpanded) {
                        submenu.classList.remove('show');
                        this.setAttribute('aria-expanded', 'false');
                    } else {
                        submenu.classList.add('show');
                        this.setAttribute('aria-expanded', 'true');
                    }
                }
            });
        });

        // Handle desktop menu items with children - allow navigation + hover dropdown
        const desktopParentItems = document.querySelectorAll('#mainNavbar .menu-item-has-children > a.dropdown-toggle');

        desktopParentItems.forEach(item => {
            const parentLi = item.parentElement;

            // Allow clicking the main link to navigate to the page
            item.addEventListener('click', function (e) {
                // Allow normal navigation - don't prevent default
                // The link will navigate to the href URL
            });

            // Show dropdown on hover
            parentLi.addEventListener('mouseenter', function () {
                const submenu = this.querySelector('.dropdown-menu');
                if (submenu) {
                    submenu.classList.add('show');
                    this.querySelector('a.dropdown-toggle').setAttribute('aria-expanded', 'true');
                }
            });

            // Hide dropdown when mouse leaves
            parentLi.addEventListener('mouseleave', function () {
                const submenu = this.querySelector('.dropdown-menu');
                if (submenu) {
                    submenu.classList.remove('show');
                    this.querySelector('a.dropdown-toggle').setAttribute('aria-expanded', 'false');
                }
            });
        });
    },


    /**
     * Sub Menus
     * Enables multilevel dropdown
     */
    subMenu: () => {
        (function ($bs) {
            const CLASS_NAME = 'has-child-dropdown-show';
            $bs.Dropdown.prototype.toggle = function (_original) {
                return function () {
                    document.querySelectorAll('.' + CLASS_NAME).forEach(function (e) {
                        e.classList.remove(CLASS_NAME);
                    });
                    let dd = this._element.closest('.dropdown').parentNode.closest('.dropdown');
                    for (; dd && dd !== document; dd = dd.parentNode.closest('.dropdown')) {
                        dd.classList.add(CLASS_NAME);
                    }
                    return _original.call(this);
                }
            }($bs.Dropdown.prototype.toggle);
            document.querySelectorAll('.dropdown').forEach(function (dd) {
                dd.addEventListener('hide.bs.dropdown', function (e) {
                    if (this.classList.contains(CLASS_NAME)) {
                        this.classList.remove(CLASS_NAME);
                        e.preventDefault();
                    }
                    e.stopPropagation();
                });
            });
        })(bootstrap);
    },

    scrollCue: () => {
        scrollCue.init({
            interval: -400,
            duration: 700,
            percentage: 0.8
        });
        scrollCue.update();
    },

    /**
     * Swiper Slider
     * Enables carousels and sliders
     * Requires assets/js/vendor/swiper-bundle.min.js
     */
    swiperSlider: function () {

        // Initialize customer experiences Swiper
        const customerExperiences = document.querySelector('.swiper.customer-experiences');

        if (customerExperiences && typeof Swiper !== 'undefined') {
            try {
                const customerExperiencesSwiper = new Swiper('.customer-experiences', {
                    slidesPerView: 1,
                    spaceBetween: 100,
                    pagination: {
                        el: '.swiper-pagination customer-experiences-pagination',
                        clickable: true,
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    autoHeight: false,
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true,
                    },
                    speed: 500,
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: false,
                    },
                });
            } catch (error) {
                console.error('Error initializing Customer Experiences Swiper:', error);
            }
        }

    },


    smoothScrollToTop: function () {
        document.addEventListener('DOMContentLoaded', function () {
            const scrollToTopButton = document.getElementById('scrollToTop');

            if (!scrollToTopButton) return;

            scrollToTopButton.addEventListener('click', () => {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            });

            window.addEventListener('scroll', () => {
                if (window.scrollY > 300) {
                    scrollToTopButton.classList.add('visible');
                } else {
                    scrollToTopButton.classList.remove('visible');
                }
            });
        });
    },

    /**
     * GLightbox
     * Enables lightbox functionality
     * Requires assets/js/vendor/glightbox.js
     */

    lightbox: () => {
        const lightbox = GLightbox({
            selector: '*[data-glightbox]',
            touchNavigation: true,
            loop: false,
            zoomable: false,
            autoplayVideos: true,
            moreLength: 0,
            slideExtraAttributes: {
                poster: ''
            },
            plyr: {
                css: '',
                js: '',
                config: {
                    ratio: '',
                    fullscreen: {
                        enabled: false,
                        iosNative: false
                    },
                    youtube: {
                        noCookie: true,
                        rel: 0,
                        showinfo: 0,
                        iv_load_policy: 3
                    },
                    vimeo: {
                        byline: false,
                        portrait: false,
                        title: false,
                        transparent: false
                    }
                }
            },
        });
    },

}
theme.init();
